import { useState } from "react";
import { Check, Copy } from "lucide-react";

import { getResolvedWorkspace } from "../providers/supabase/workspaceConfig";

/**
 * One-click copy of this workspace's BCC/forward capture address (decision
 * #46/#47) - the fastest way to grab it without a trip to Settings ->
 * Integrations. Renders nothing until a real workspace has resolved (demo
 * preview, or before the runtime workspace lookup completes) - same
 * resolution TrackingPage/IntegrationsPage use, not a placeholder address.
 */
export const BccCopyButton = () => {
  const [copied, setCopied] = useState(false);
  const slug = getResolvedWorkspace()?.slug;
  if (!slug) return null;
  const address = `log-${slug}@mail.obviouscrm.com`;

  return (
    <button
      type="button"
      title={`Copy BCC capture address (${address})`}
      aria-label="Copy BCC capture address"
      onClick={() => {
        void navigator.clipboard.writeText(address);
        setCopied(true);
        setTimeout(() => setCopied(false), 1600);
      }}
      className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md text-xs text-secondary-foreground/70 hover:text-secondary-foreground hover:bg-secondary-foreground/10 transition-colors shrink-0"
    >
      {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
      <span className="hidden lg:inline">{copied ? "Copied" : "BCC address"}</span>
    </button>
  );
};
